var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { memo, useMemo } from 'react';
import { getCustomSelectFieldDisplayValue, } from 'utils/customFields';
import { convertTreeToFlatItems } from 'utils/tree';
import styles from './customFieldChip.module.scss';
/**
 * Presents a chip containing value and label. It also shows a tooltip if there
 * is description.
 */
export const CustomFieldChip = memo(function CustomFieldChip(_a) {
    var { className, customField } = _a, flexProps = __rest(_a, ["className", "customField"]);
    const { attribute, value } = customField;
    const displayedValue = useMemo(() => {
        if (value.data_type === 'string') {
            return _jsx(Value, { children: value.value });
        }
        if ('options' in attribute && value.data_type === 'string_set') {
            const flatOptions = convertTreeToFlatItems(attribute.options, {
                childrenKey: 'options',
            });
            const hasHierarchy = flatOptions.some((option) => option.parent_id);
            if (!hasHierarchy) {
                return (_jsx(Value, { children: value.value
                        .map((value) => { var _a; return (_a = flatOptions.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label; })
                        .filter(Boolean)
                        .join(', ') }));
            }
            const displayValue = getCustomSelectFieldDisplayValue({ attribute, value }, { nodeClassName: styles.subdued, separatorClassName: styles.subdued });
            if (!displayValue) {
                return '';
            }
            return (_jsx(Tooltip, Object.assign({ content: displayValue.rawPath, dark: true, disabled: !displayValue.isLongPath }, { children: _jsx(Value, { children: displayValue.path }) })));
        }
    }, [attribute, value]);
    return (_jsxs(FlexBox, Object.assign({ className: classnames(styles.chip, className), alignItems: "center" }, flexProps, { children: [_jsx(Tooltip, Object.assign({ content: attribute.description, disabled: !attribute.description, dark: true }, { children: _jsx(Box, Object.assign({ className: styles.chipLabel }, { children: attribute.label })) })), displayedValue] })));
});
const Value = ({ children }) => {
    return _jsx(Box, Object.assign({ className: styles.chipValue }, { children: children }));
};
